export const getSku = () => {
  const hashes = window.location.search.slice(window.location.search.indexOf('?') + 1).split('&');
  const params = {};
  hashes.forEach((hash) => {
    const [key, val] = hash.split('=');
    params[key] = decodeURIComponent(val);
  });
  return params.sku;
};



// WEBPACK FOOTER //
// ./src/helpers/url.js